import { createSlice } from "@reduxjs/toolkit";

export const SUPPORTED_LANGUAGES = ["en", "fr", "ar"];
export const RTL_LANGUAGES = ["ar"];

const getInitialLanguage = () => {
  const stored = localStorage.getItem("lang");
  return SUPPORTED_LANGUAGES.includes(stored) ? stored : "en";
};

const initialState = {
  current: getInitialLanguage(),
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      const lang = action.payload;
      if (!SUPPORTED_LANGUAGES.includes(lang)) return;
      state.current = lang;
      localStorage.setItem("lang", lang);
    },
  },
});

export const languageActions = languageSlice.actions;
export const languageReducer = languageSlice.reducer;
